import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import imageDesktopWebp from './images/culture-desktop.webp';
import imageMobileWebp from './images/culture-mobile.webp';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-culture'
    moduleName='financial-planning-module'
    themeType='lightTheme'
    backgroundVariant='lightB'
    reverseContent
    // content
    subHeadingText={<>Strengthening our culture <WidowBlock>of belonging</WidowBlock></>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='button'>
          We invest in our people and our culture to enable everyone&#39;s success, making Northwestern Mutual an employer of choice.
        </Typography>
        <Link
          id='sustainability-impact-culture-link'
          variant='buttonLinkSecondary'
          linkUrl='/who-we-are/sustainability-impact/culture/'
          ariaLabel='Find out more about our culture.'>
          Find out more
        </Link>
      </>
    )}
    // image props
    imageAltText='An aerial view of culturally&#45;diverse employees standing in an open workspace, forming the letters &#39;NM&#39; with their bodies'
    imageSrcDefault={imageDesktopWebp}
    imageSrcMobile={imageMobileWebp}
  />
);
